const libraryName = '@lts-web';

/**
 * Get object's value by path
 * @param object
 * @param path
 * @param joiner
 * @returns {*}
 */
function getFromObject(object, path, joiner) {
    var keys = path.split(joiner || '.');

    var i = 0;
    var tmp = object;
    var len = keys.length;

    while (i < len) {
        var key = keys[i++];
        if (!tmp || !hasOwnProperty.call(tmp, key)) {
            return tmp = undefined;
        }
        tmp = tmp[key];
    }

    return tmp;
}

 const capitalize = (input) => input.replace(/(^|[\s-])\S/g, (match) => match.toUpperCase()).replace(/-/g, '');

/* Export */
export const requireModule = (path) => {
    const relative = path.replace(libraryName, '');
    const fullPath = libraryName + capitalize(relative);

    return getFromObject(window, fullPath, '/');
};

/* Expose Globally */
window.require = requireModule;